import React, { useState } from 'react';
import cardIcon from '../assets/card_icon.png';
import CollectionModal from './CollectionModal';

export default function CollectionButton() {
    const [open, setOpen] = useState(false);

    return (
        <>
            <button
                onClick={() => setOpen(true)}
                style={{
                    position: 'absolute',
                    top: 62,
                    right: 0,
                    zIndex: 1200,
                    border: 'none',
                    background: 'transparent',
                    cursor: 'pointer',
                }}
            >
                <div style={{ position: 'relative' }}>
                    {/* Hue rotate to distinguish from others, assuming purple/pinkish for collection */}
                    <img src={cardIcon} alt="Collection" style={{ width: 70, height: 70 }} />
                    <div style={{
                        position: 'absolute',
                        bottom: 0,
                        width: '100%',
                        textAlign: 'center',
                        color: 'white',
                        fontSize: '10px',
                        fontWeight: 'bold',
                        textShadow: '1px 1px 2px black'
                    }}>

                    </div>
                </div>
            </button>
            <CollectionModal open={open} onClose={() => setOpen(false)} />
        </>
    );
}
